export const ASSISE_RESET = "ASSISE_RESET";
export const ASSISE_SET_ERROR = "ASSISE_SET_ERROR";
export const ASSISE_SET_ITEMS = "ASSISE_SET_ITEMS";
export const ASSISE_TOGGLE_LOADING = "ASSISE_TOGGLE_LOADING";
